<template>
  <v-card flat>
    <v-card-title primary-title>
      <h3 class="display-1 mb-3">Allgemeine Informationen</h3>
      <h5 class="subheading mb-0">Diese Daten dienen zur Anzeige auf Ihrem öffentlichen Profil sowie für das gesetzlich vorgeschriebene Impressum. Geben Sie keine persönliche Daten an und wenn Sie irgendetwas nicht angeben wollen, lassen Sie das Feld bitte einfach leer.</h5>
    </v-card-title>
<v-card-text>
<div v-if="this.$store.getters.authBetrieb && betrieb">
   <form v-on:submit="saveForm()">

         <v-layout row>
          <v-flex xs4>
            <v-subheader>Name des Betriebs</v-subheader>

          </v-flex>
            <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Name des Betriebs"
              v-model="betrieb.name"
            ></v-text-field>
         
          </v-flex>
         
        </v-layout>

            <v-layout row>
          <v-flex xs4>
            <v-subheader>Prefix des Namens</v-subheader>

          </v-flex>
            <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Erscheint vor dem Namen aber wird bei alphabetischer Sortierung ignoriert. *optional"
              v-model="betrieb.prefix"
            ></v-text-field>
         
          </v-flex>
         
        </v-layout>

       <!--   <v-layout row>
          <v-flex xs4>
            <v-subheader>Innung
            {{ betrieb.kategorie }}</v-subheader>
          </v-flex>
          
           <v-flex xs8 lg8>
             <v-select
              :items="innungen"
              item-value="id"
              v-model="betrieb.kategorie"
              label="Auswählen"
              single-line
            ></v-select>


          </v-flex>
        </v-layout>
 -->

         <v-layout row>
          <v-flex xs4>
            <v-subheader>Name nach Handwerksrolle</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Name nach Handwerksrolle"
              v-model="betrieb.chef"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs4>
            <v-subheader>Anschrift</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Straße mit Hausnummer"
              v-model="betrieb.address"
            ></v-text-field>
          </v-flex>
        </v-layout>

    <v-layout row>
          <v-flex xs4>
            <v-subheader>Postleitzahl</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Postleitzahl"
              v-model="betrieb.plz"
            ></v-text-field>
          </v-flex>
        </v-layout>

    <v-layout row>
          <v-flex xs4>
            <v-subheader>Stadt</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Stadt"
              v-model="betrieb.stadt"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs4>
            <v-subheader>Stadtteil</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Stadtteil"
              v-model="betrieb.stadtteil"
            ></v-text-field>
          </v-flex>
        </v-layout>

    <v-layout row>
          <v-flex xs4>
            <v-subheader>Telefonnummer</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Telefonnummer"
              v-model="betrieb.telefon"
              append-icon="phone"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs4>
            <v-subheader>Faxnummer</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Faxnummer"
              v-model="betrieb.fax"
              append-icon="message"
            ></v-text-field>
          </v-flex>
        </v-layout>


        <v-layout row>
          <v-flex xs4>
            <v-subheader>Webseite</v-subheader>
          </v-flex>
          <v-flex xs8 lg8>
            <v-text-field
              name="input-1"
              label="Webseite (Bitte mit https:// eingeben)"
              v-model="betrieb.website"
              append-icon="web"
              value="http://"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs3>
            <v-subheader>Bitte Ihre öffentliche Geschäftsadresse eintragen.</v-subheader>
          </v-flex>
          <v-flex xs8 offset-xs1 lg8 offset-lg1>
            <v-text-field
              name="input-1"
              label="Email"
              v-model="betrieb.email"
              append-icon="email"
            ></v-text-field>
          </v-flex>
        </v-layout>


    </form>



 <v-layout row class="mt-3">
       <v-flex xs4>
        &nbsp;
       </v-flex>
       <v-flex xs4 class="text-xs-center">
        <v-btn v-on:click.native="saveForm()" large color="accent">Speichern</v-btn>
       </v-flex>
       <v-flex xs4 class="text-xs-right">
          <v-btn @click="nexttab()" large>Weiter <v-icon right>chevron_right</v-icon></v-btn>
       </v-flex>
    </v-layout>

</div>
<div v-else>
  
  
   <v-alert outline color="info" icon="info" :value="true">
     Aktuell ist noch kein Betrieb mit Ihrem Nutzer-Account verknüpft, Bitte melden Sie sich bei uns, damit wir Sie verifizieren können: 
        <v-btn href="mailto:info@lokaleshandwerk.de"><v-icon left >mail</v-icon>info@lokaleshandwerk.de</v-btn>

    </v-alert>
</div>
  </v-card-text>


  </v-card>
</template>

<script>
// import Form from 'vform'
// import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'profile-view',
  props: {
    betrieb: Object,
    loading: Boolean
  },

  mounted () {
            // let app = this;
            // axios.get('/api/v1/meinbetrieb' )
            //     .then(function (resp) {
            //         app.company = resp.data;

            //     })
            //     .catch(function () {
            //         console.log('keine Betrieb verknüpft')
            //     });
  },
  data: function () {
    return {
      e1: '4',
      companyId: '',
      company: {
        name: '',
        address: '',
        website: '',
        email: '',
        kurztext: ' ',
        kategorie: ''
      }
    }
  },
  methods: {
    nexttab (event) {
      this.$emit('tabswitch')
    },
    saveForm () {
      var app = this
      var newCompany = app.betrieb

      axios.patch('/api/v1/companies/' + app.betrieb.id, newCompany)
        .then((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: this.$t('betrieb_updated')
          })
        // app.$router.replace('/meinbetrieb')
        })
      .catch((resp) => {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: this.$t('error_alert_text')
        })
      })
    }
  }
}

// export default {
//   data: () => ({
//     form: new Form({
//       name: '',
//       email: ''
//     })
//   }),

//   computed: mapGetters({
//     user: 'authUser'
//   }),

//   created () {
//     this.form.keys().forEach(key => {
//       this.form[key] = this.user[key]
//     })
//   },

//   methods: {
//     async update () {
//       if (await this.formHasErrors()) return

//       const { data } = await this.form.patch('/api/settings/profile')

//       await this.$store.dispatch('updateUser', { user: data })
//       this.$emit('busy', false)
//     }
//   },

//   watch: {
//     form () {
//       console.log(this.form)
//     }
//   }
// }
</script>
